import { Injectable } from '@angular/core';

import { ServiceRequest } from 'src/app/models/service-request';
import { environment } from 'src/environment/environment';
import { CrudService } from '../crud/crud.service';
import { HttpService } from '../http/http.service';

@Injectable({
  providedIn: 'root',
})
export class ServiceRequestService extends CrudService<ServiceRequest> {
  constructor(http: HttpService) {
    super('service-request', http);
  }

  // override getById method for this service
  override async getById(id: string): Promise<ServiceRequest> {
    const url = `${environment.apiUrl}/admin/service-request/${id}`;
    const response = await this.http.get<ServiceRequest>(url);
    if (!response.success) throw new Error(response.message);
    return response.data;
  }

  // recreate a service request with a specific ID (admin-only operation)
  async recreate(id: string, data: Partial<ServiceRequest>): Promise<ServiceRequest> {
    const url = `${environment.apiUrl}/service-request/${id}/recreate`;
    const response = await this.http.post<ServiceRequest>(url, data);
    if (!response.success) throw new Error(response.message);
    return response.data;
  }

  // override methods which are not available for this service

  override create(data: Partial<ServiceRequest>): Promise<ServiceRequest> {
    throw new Error('Method not available.');
  }
  override update(data: Partial<ServiceRequest>): Promise<ServiceRequest> {
    throw new Error('Method not available.');
  }
  override delete(id: string): Promise<string> {
    throw new Error('Method not available.');
  }
}
